import AGLocationsMap from './AGLocationsMap.client'

export default AGLocationsMap
